import React from "react";
import { Building2, FileText, Hash, IdCard } from "lucide-react";
import { Sekcja, RowIcon, mono } from "./atoms";

export default function DanePodstawoweSection({ krs }) {
  return (
    <Sekcja
      title="Dane podstawowe"
      icon={Building2}
      titleStyle={{ fontSize: 20, color: "#0b74e5", textDecorationThickness: "2px", textUnderlineOffset: 4 }}
    >
      
      <div className="sectionGrid">
        <div>          
          <RowIcon icon={FileText} label="Nazwa">{krs?.name}</RowIcon>
          <RowIcon icon={Building2} label="Forma prawna">{krs?.legal_form}</RowIcon>
        </div>
        <div>
          <RowIcon icon={IdCard} label="NIP">{mono(krs?.nip)}</RowIcon>
          <RowIcon icon={Hash} label="REGON">{mono(krs?.regon)}</RowIcon>
          <RowIcon icon={Hash} label="KRS">{mono(krs?.krs)}</RowIcon>
        </div>
      </div>
    </Sekcja>
  );
}
